import React from "react";
import GlobalFilter from "../../Utility/GlobalFilter/GlobalFilter";

export default function TeamFilter({
  listingFilter,
  handleFilterChange,
  handleFilterReset,
  applyFilters,
}) {
  const handleStatusChange = (e) => {
    const value = e.target.value === "All" ? "" : e.target.value;
    handleFilterChange({
      target: {
        name: "status",
        value: value,
      },
    });
  };

  const fields = [
    {
      type: "input",
      name: "teamName",
      label: "Team Name",
      placeholder: "Enter team name",
    },
    {
      type: "dropdown",
      name: "status",
      label: "Status",
      options: ["All", "Active", "Inactive"],
      placeholder: "All",
      onChange: handleStatusChange,
    },
  ];

  return (
    <GlobalFilter
      listingFilter={listingFilter}
      handleFilterChange={handleFilterChange}
      handleFilterReset={handleFilterReset}
      applyFilters={applyFilters}
      fields={fields}
      // columns={3}
      buttonWidth="w-full md:w-auto"
      flexClassName="flex flex-wrap md:flex-nowrap gap-2 items-end"
    />
  );
}
